function Header() {
    $(".header-bars").on("click", function (e) {
        e.preventDefault();
        e.stopPropagation();
        $("body").toggleClass("lg-ovf-hidden");
        $(".header").toggleClass("header-mb");
    });

    $(".header-lang-selected").on("click", function (e) {
        e.preventDefault();
        e.stopPropagation();
        $(".header-lang").toggleClass("active");
    });

    $(document).on("click", function () {
        $(".header-lang").removeClass("active");
    });

    $(".header-lang, .header-lang-selected").on("click", function (e) {
        e.stopPropagation();
    });

    var header = $(".header");
    $(window).scroll(function () {
        var scroll = $(window).scrollTop();
        if (scroll >= 96) {
            header.addClass("scrolled");
        } else {
            header.removeClass("scrolled");
        }
    });

    $('.header-nav-list-item[data-dropdown="true"] > .header-nav-link').on(
        "click",
        function (e) {
            e.preventDefault();

            var parentItem = $(this).closest(".header-nav-list-item");

            $('.header-nav-list-item[data-dropdown="true"].active')
                .not(parentItem)
                .removeClass("active");

            parentItem.toggleClass("active");
        },
    );

    $(window).scroll(function () {
        if (
            !localStorage.getItem("up-alert") ||
            localStorage.getItem("up-alert") !== "true"
        ) {
            $(".up-alert").addClass("show");
        }
        $(".up-alert .up-alert-close").on("click", function () {
            localStorage.setItem("up-alert", true);
            $(".up-alert").removeClass("show");
        });
        $(".up-alert .up-alert-close").click(function () {
            $(".up-alert").removeClass("show");
        });
    });
}

Header();
